import React from 'react';

export default function TheTide() {
  return (
    <section id="l2" className="chapter">
      <div style={{ maxWidth: 1200 }}>
        <div className="chapter-eyebrow font-sans">LIFE II &middot; THE LINEAGE</div>
        <p className="big-prose">
          First, <em><i>Doge</i></em> broke the surface.<br />
          Then <em><i>Cate</i></em> claimed the ninth life.<br />
          <span className="fade">Now the water is stirring —</span><br />
          something <em><i>golden</i></em> is rising from below.
        </p>

        <div className="lineage-row">
          <div className="lineage-card">
            <div className="lineage-year">2013</div>
            <div className="lineage-name">DOGE</div>
            <div className="lineage-role">The Ancestor</div>
            <p className="lineage-note">The joke that outran the market. Proof that culture beats whitepapers.</p>
          </div>
          <div className="lineage-arrow">&rarr;</div>
          <div className="lineage-card">
            <div className="lineage-year">2025</div>
            <div className="lineage-name">CATE</div>
            <div className="lineage-role">The Sister</div>
            <p className="lineage-note">Nine lives, one ninth-inning rally. She showed cats belonged on-chain too.</p>
          </div>
          <div className="lineage-arrow">&rarr;</div>
          <div className="lineage-card active">
            <div className="lineage-year">NOW</div>
            <div className="lineage-name">FISHE</div>
            <div className="lineage-role">The Next</div>
            <p className="lineage-note">A goldfish forged from bullion. The trilogy's finale — and the biggest run yet.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
